export var single = [
  {
    "name": "Pre Auth Registration",
    "value": '6 Hrs'
  },
  {
    "name": "Health Claim Registration",
    "value": '8 Hrs'
  },
  {
    "name": "New Proposal Registration",
    "value": '5 Hrs'
  }
];